<template>
  <footer class="footer">
    © {{ currentYear }} {{ siteName }}

    <div class="footer-links">
      <ul>
        <li
          v-for="(item, index) in footerLinks"
          :key="index"
          class="footer-link-item">

          &nbsp; / &nbsp;
          <router-link :to="item.url">
            {{ item.name }}
          </router-link>

        </li>
      </ul>
    </div>

  </footer>
</template>

<script>
export default {
  name: 'page-footer',
  props: {
    siteName: {
      type: String,
      required: true
    },
    footerLinks: {
      type: Array,
      required: true
    }
  },
  computed: {
    currentYear () {
      return (new Date()).getFullYear()
    }
  }
}
</script>

<style scoped>

</style>
